import { Component, Input, OnInit } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { GeoLocationService } from "src/app/_services/geoLocation.service";

@Component({
  selector: "app-location-permission-alert",
  templateUrl: "./location-permission-alert.component.html",
  styleUrls: ["./location-permission-alert.component.scss"],
})
export class LocationPermissionAlertComponent implements OnInit {
  @Input() title?: string;
  @Input() message?: string;
  @Input() buttonText?: string;

  constructor(
    private alertController: AlertController,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (!this.title) {
      this.title = this.translate.instant("PERMISSIONS.STEPPER.LOCATION_TITLE");
    }
    if (!this.message) {
      this.message = this.translate.instant("PERMISSIONS.STEPPER.LOCATION_DESCRIPTION");
    }
    if (!this.buttonText) {
      this.buttonText = this.translate.instant("APP_PAGE.ACCEPT") || "OK";
    }
  }

  async present(): Promise<any> {
    const title = this.title ?? this.translate.instant("PERMISSIONS.STEPPER.LOCATION_TITLE");
    const message =
      this.message ?? this.translate.instant("PERMISSIONS.STEPPER.LOCATION_DESCRIPTION");
    const translatedAccept = this.translate.instant("APP_PAGE.ACCEPT");
    const buttonText = this.buttonText ?? translatedAccept ?? "OK";

    const alert = await this.alertController.create({
      header: title,
      message: message,
      buttons: [
        {
          text: buttonText,
          role: "cancel",
          cssClass: "alert-button-confirm",
        },
      ],
      backdropDismiss: false,
      cssClass: "location-permission-alert",
      mode: "ios",
    });

    await alert.present();
    return alert.onDidDismiss();
  }

  private static isAlertShowing = false;

  static async showAlert(
    alertController: AlertController,
    translateService: TranslateService,
    geoLocationService?: GeoLocationService,
    customTitle?: string,
    customMessage?: string,
    customButtonText?: string
  ): Promise<any> {
    if (this.isAlertShowing) {
      return Promise.resolve();
    }

    try {
      this.isAlertShowing = true;
      const title = customTitle || translateService.instant("PERMISSIONS.STEPPER.LOCATION_TITLE");
      const message =
        customMessage || translateService.instant("PERMISSIONS.STEPPER.LOCATION_DESCRIPTION");
      const requestButtonText =
        customButtonText || translateService.instant("PERMISSIONS.STEPPER.ACTION_LOCATION") || "Autoriser";
      const cancelButtonText = "Annuler";

      if (!geoLocationService) {
        this.isAlertShowing = false;
        return Promise.resolve();
      }

      const buttons: any[] = [
        {
          text: cancelButtonText,
          role: "cancel",
          cssClass: "alert-button-cancel",
        },
        {
          text: requestButtonText,
          handler: async () => {
            try {
              await geoLocationService.requestLocationPermission();
              return true;
            } catch {
              return false;
            }
          },
          cssClass: "alert-button-confirm",
        },
      ];

      const alert = await alertController.create({
        header: title,
        message: message,
        buttons: buttons,
        backdropDismiss: false,
        cssClass: "location-permission-alert",
        mode: "ios",
      });

      await alert.present();
      alert.onDidDismiss().then(() => {
        this.isAlertShowing = false;
      });
      return alert.onDidDismiss();
    } catch {
      this.isAlertShowing = false;
      return Promise.resolve();
    }
  }
}
